export const PACKAGES = [
    {
        id: "starter",
        name: "Starter Boost",
        price: 50,
        views: "1,000+",
        influencers: "10 Posters/Influencers",
        tagline: "Test the waters",
        features: ["1,000+ verified views", "10 posters/influencers", "Screenshot proof", "24-hour campaign"],
        featured: false,
    },
    {
        id: "growth",
        name: "Growth Accelerator",
        price: 100,
        views: "2,500+",
        influencers: "20 Posters/Influencers",
        tagline: "Build momentum",
        features: ["2,500+ verified views", "20 posters/influencers", "Screenshot proof", "Demographic targeting"],
        featured: false,
    },
    {
        id: "momentum",
        name: "Momentum Package",
        price: 200,
        views: "6,000+",
        influencers: "40 Posters/Influencers",
        tagline: "Scale your reach",
        features: ["6,000+ verified views", "40 posters/influencers", "Screenshot proof", "Location + demo targeting"],
        featured: false,
    },
    {
        id: "power",
        name: "Power Package",
        price: 350,
        views: "11,000+",
        influencers: "60 Posters/Influencers",
        tagline: "Premium exposure",
        features: ["11,000+ verified views", "60 posters/influencers", "Priority distribution", "Full campaign report"],
        featured: false,
    },
    {
        id: "viral",
        name: "Viral Package",
        price: 500,
        views: "18,000+",
        influencers: "100+ Posters/Influencers",
        tagline: "Go viral",
        features: ["18,000+ verified views", "100+ posters/influencers", "Maximum distribution", "Full proof + analytics", "Priority placement"],
        featured: true,
    },
];

export const AGENCY_PACKAGES = [
    { id: "agency-750", price: 750, influencers: "135–270", views: "28,000+" },
    { id: "agency-995", price: 995, influencers: "180–360", views: "40,000+" },
    { id: "agency-1745", price: 1745, influencers: "340–680", views: "70,000+" },
    { id: "agency-2485", price: 2485, influencers: "500–1,000", views: "100,000+" },
    { id: "agency-3975", price: 3975, influencers: "820–1,640", views: "160,000+" },
    { id: "agency-5945", price: 5945, influencers: "1,220–2,440", views: "240,000+" },
    { id: "agency-7425", price: 7425, influencers: "1,540–3,080", views: "300,000+" },
    { id: "agency-10000", price: 10000, influencers: "2,100–4,200", views: "405,000+" },
];

export const INDUSTRIES = [
    { name: "Real Estate", icon: "House" },
    { name: "Healthcare", icon: "Heartbeat" },
    { name: "Home Services", icon: "Wrench" },
    { name: "Events", icon: "Confetti" },
    { name: "E-Commerce", icon: "ShoppingCart" },
    { name: "Restaurants", icon: "ForkKnife" },
    { name: "Insurance", icon: "ShieldCheck" },
    { name: "Financial Services", icon: "Bank" },
    { name: "Local Businesses", icon: "Storefront" },
    { name: "Job Recruitment", icon: "Briefcase" },
];

export const LOCATIONS = [
    { name: "New York", flag: "🇺🇸" },
    { name: "New Jersey", flag: "🇺🇸" },
    { name: "Florida", flag: "🇺🇸" },
    { name: "Ohio", flag: "🇺🇸" },
    { name: "California", flag: "🇺🇸" },
    { name: "Illinois", flag: "🇺🇸" },
    { name: "Israel", flag: "🇮🇱" },
    { name: "Canada", flag: "🇨🇦" },
    { name: "United Kingdom", flag: "🇬🇧" },
];

export const POSTER_TIERS = [
    { range: "Under 50 Views", pay: "$3" },
    { range: "50–249 Views", pay: "$5" },
    { range: "250–999 Views", pay: "$10" },
    { range: "1,000+ Views", pay: "$15" },
    { range: "2,000+ Views", pay: "$20" },
];

export const FAQS = [
    { q: "How quickly can my campaign launch?", a: "Usually within 1–24 hours after we receive your creative and confirm payment." },
    { q: "Can I target specific locations?", a: "Yes. We segment by city, state, country, community, and even neighborhood when relevant." },
    { q: "Can I target specific demographics?", a: "Yes. Age, gender, profession, industry, business owners, and community groups are all supported." },
    { q: "Do you provide proof?", a: "Every campaign comes with screenshot verification from each live account that posted your ad." },
    { q: "How long do ads stay up?", a: "Ads remain live for a minimum of 24 hours on each poster's status feed." },
];

export const TESTIMONIALS = [
    {
        quote: "I was skeptical about 'getting paid to post' jobs, but CashFlow Ads is the real deal. I just post the status, send my screenshot, and the money hits my PayPal every other Sunday like clockwork. It's the easiest side hustle I've ever found. Highly recommend to anyone looking to make some extra cash from their phone!",
        name: "Yaakov M.",
        role: "Poster · Lakewood",
    },
    {
        quote: "Working with CashFlow Ads completely changed how we approach advertising. Their strategy helped us reach new customers faster than we expected.",
        name: "Menachem M.",
        role: "Real Estate Broker · Crown Heights",
    },
    {
        quote: "The team at CashFlow Ads is creative, responsive, and focused on results. Our campaigns are performing better than ever.",
        name: "Chaim W.",
        role: "Marketing Director · Boro Park",
    },
    {
        quote: "We appreciated the clear communication and measurable outcomes. CashFlow Ads made the entire advertising process easy to understand.",
        name: "Yosef R.",
        role: "Insurance Agent · Monsey",
    },
    {
        quote: "What I love most about this service is that it's run by real people, not bots. Whenever I have a question about a payout or a specific ad, I get a personal response. I'm currently at the $15 per ad tier and it's amazing how quickly the views add up. Every view really does count toward the payout!",
        name: "Dovid R.",
        role: "Poster · Five Towns",
    },
    {
        quote: "As an online brand, I was tired of paying for the usual strategies. I started with the Growth Package and saw over 2,500 real views from active users. The screenshot verification gave me the transparency I've been missing with other networks.",
        name: "Chaya L.",
        role: "E-Commerce Founder · Lakewood",
    },
    {
        quote: "Targeting the Jewish community in Lakewood and Brooklyn used to be expensive, but this network made it simple. We used the Momentum Package for our latest sale, and the status views turned into our busiest weekend yet.",
        name: "Moshe S.",
        role: "Local Business Owner · Flatbush",
    },
    {
        quote: "I needed a massive push for my latest project launch, and the Viral Package delivered exactly what was promised. Having 100+ micro-influencers manually post my content created a buzz that felt natural and authentic. Best value for high-impact visibility.",
        name: "Shmuly H.",
        role: "Event Planner · Williamsburg",
    },
];
